import { ProductOrBrand } from "./alternativeTypes";

export const officeProducts: ProductOrBrand[] = [
  {
    name: "Post-it",
    ownerCountry: "US", // 3M
    categories: ["office", "sticky-notes"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Post-it_note", "https://en.wikipedia.org/wiki/3M"]
  },
  {
    name: "Scotch",
    ownerCountry: "US", // 3M
    categories: ["office", "tape"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Scotch_tape"]
  },
  {
    name: "3M",
    ownerCountry: "US",
    categories: ["office", "tape", "office-tools"],
    sourceLinks: ["https://en.wikipedia.org/wiki/3M"]
  },
  {
    name: "Rexel",
    ownerCountry: "US", // ACCO Group
    categories: ["office", "office-tools"]
  },
  {
    name: "Leitz",
    ownerCountry: "US", // ACCO Group
    categories: ["office", "office-tools"]
  },
  {
    name: "Esselte",
    ownerCountry: "US", // Esselte -> ACCO
    headquarterIn: "SE",
    categories: ["office", "notebooks"]
  },
  {
    name: "Kensington",
    ownerCountry: "US", // Esselte -> ACCO
    categories: ["office", "pens"],
    sourceLinks: ["https://www.accobrands.com/brands/"]
  },
  {
    name: "Rapid",
    ownerCountry: "US", // Esselte -> ACCO
    headquarterIn: "SE",
    categories: ["office", "office-tools"]
  },
  {
    name: "Sharpie",
    ownerCountry: "US",
    categories: ["office", "markers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Sharpie_(marker)"]
  },
  {
    name: "nobo",
    ownerCountry: "US", // ACCO
    categories: ["office", "whiteboards"],
    sourceLinks: ["https://services.patentstyret.no/search-details/trademark/200901098-0989838?lang=no"]
  },

  {
    name: "Posca",
    include: false,
    ownerCountry: "JP", 
    categories: ["office", "markers"],
    sourceLinks: ["https://www.posca.com/en/"]
  },
  {
    name: "Pilot",
    ownerCountry: "JP",
    categories: ["office", "pens"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Pilot_(pen_company)"]
  },

  {
    name: "Oxford",
    ownerCountry: "FR", // Hamelin Group
    categories: ["office", "notebooks"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Esselte",
      "https://services.patentstyret.no/search-details/trademark/200300218-0793095?lang=no",
      "https://www.hamelinbrands.com/brands/hamelin/",
      "https://www.linkedin.com/company/hamelinbrands/"
    ]
  },  
  {
    name: "Lyreco",
    ownerCountry: "FR",
    categories: ["office", "office-tools", "markers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Lyreco"]
  },
  {
    name: "Info Notes",
    ownerCountry: "FI", // AMC AG -> UPM Raflatac
    categories: ["office", "sticky-notes"],
    sourceLinks: ["https://www.officeproducts.upmraflatac.com/news/2022/amc-ag-is-acquired-by-upm-raflatac/"]
  },
  {
    name: "BiC",
    ownerCountry: "FR",
    categories: ["office", "pens"],
  },
  {
    name: "Durable",
    ownerCountry: "DE",
    categories: ["office", "office-tools"],
    sourceLinks: ["https://de.wikipedia.org/wiki/Durable"]
  },
  {
    name: "Bantex",
    ownerCountry: "DK",
    categories: ["office", "notebooks"],
    sourceLinks: ["https://da.wikipedia.org/wiki/Bantex"]
  },
  {
    name: "Burde",
    ownerCountry: "SE",
    categories: ["office", "notebooks"],
    sourceLinks: ["https://burde.com/se/om-burde/", "https://www.allabolag.se/foretag/burde-group-ab/växjö/fastighetsbolag-lokaler/2K01ENNI5YDUJ"]
  },
  {
    name: "Grieg",
    ownerCountry: "SE",
    categories: ["office", "notebooks"],
    sourceLinks: ["https://burde.com/se/om-burde/", "https://www.allabolag.se/foretag/burde-group-ab/växjö/fastighetsbolag-lokaler/2K01ENNI5YDUJ"]
  },
  {
    name: "EMO",
    ownerCountry: "FR",
    categories: ["office", "notebooks"],
    sourceLinks: ["https://www.lyreco.com/group/ce/en/international-leadership/blog/staples-becomes-lyreco"]
  },
  {
    name: "Exacompta",
    ownerCountry: "FR", // Exacompta Clairfontane
    categories: ["office", "notebooks"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Clairefontaine_paper_mills"]
  },
  {
    name: "Faber-Castell",
    ownerCountry: "DE",
    categories: ["office", "pens"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Faber-Castell"]
  },
  {
    name: "Edding",
    ownerCountry: "DE",
    categories: ["office", "markers"],
    sourceLinks: ["https://de.wikipedia.org/wiki/Edding"]
  },
  {
    name: "Bi-Office",
    ownerCountry: "PT",
    categories: ["office", "whiteboards"],
    sourceLinks: ["https://www.bi-office.com"]
  },
  {
    name: "Maped",
    ownerCountry: "FR",
    categories: ["office", "markers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Maped"]
  },
  {
    name: "Staedtler",
    ownerCountry: "DE",
    categories: ["office", "markers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Staedtler"]
  },
  {
    name: "Tesa",
    ownerCountry: "DE",
    categories: ["office", "tape"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Tesa_SE"]
  },
  // https://www.topstar.de/en
]